import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
/* eslint no-param-reassign: 0 */

import produce from 'immer';
import _findIndex from 'lodash/findIndex';

// Constants
import { EMPTY_OBJECT, EMPTY_ARRAY } from '@tekion/tekion-base/app.constants';
var findAndReplace = function findAndReplace(findQuery, replacement) {
  var list = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : EMPTY_ARRAY;
  var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : EMPTY_OBJECT;
  var indexToReplace = _findIndex(list, findQuery);
  var addIfNotPresent = options.addIfNotPresent;
  if (indexToReplace !== -1) {
    return produce(list, function (draftList) {
      draftList[indexToReplace] = replacement;
    });
  }
  if (addIfNotPresent) {
    return [].concat(_toConsumableArray(list), [replacement]);
  }
  return list;
};
export default findAndReplace;